const cloudName = "dy6yrdnwo";
const upload_preset = "akswb21";

const UploadImg = async (file) => {
  console.log("Enterr");
  console.log("cloudName====>", cloudName);
  console.log("Upload_preset=========>", upload_preset);
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", upload_preset);

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await response.json();
  console.log("data--------->", data);

  if (!response.ok) {
    console.error("Cloudinary Error Response:", data);
    throw new Error(data?.error?.message || "Image upload failed");
  }
  console.log("data secure ulr --------->", data.secure_url);
  return data.secure_url;
};

export default UploadImg;
